import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidEnvelopeAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 16c-.6 0-1.1-.2-1.6-.4L2 10.4V17c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-6.6l-8.4 5.2c-.5.2-1 .4-1.6.4Zm7-12H5C3.3 4 2 5.3 2 7v1.1l9.5 5.8c.3.2.7.2 1 0L22 8.1V7c0-1.7-1.3-3-3-3Z"/>
  </SvgIcon>
}

export default SolidEnvelopeAltIcon
